import { Component, OnInit } from '@angular/core';
import { GlobalServices } from 'src/app/shared/services/global.service';
import { AlertService } from 'src/app/shared/components/alert/alert.service';
import { AgentService } from '../shared/services/agent.service';
import { TranslateService } from '@ngx-translate/core';
import { ActivatedRoute } from '@angular/router';

@Component({
  selector: 'app-deactivate-agent-representative',
  templateUrl: './deactivate-agent-representative.component.html',
  styleUrls: ['./deactivate-agent-representative.component.css']
})
export class DeactivateAgentRepresentativeComponent implements OnInit {

  agentId: string;
  showRequest = false
  isErrorMessage: boolean= false;
  constructor(private globalSrv: GlobalServices, private alertService: AlertService,
    private agentSrv: AgentService,
    private translate: TranslateService,  private route: ActivatedRoute,) {

   
      this.agentId = this.route.snapshot.params.Id;
    
    if (this.agentId) {
      this.deActivate(this.agentId);
    }
  }

  ngOnInit() {
  }
  deActivate(agentId) {
    this.agentSrv.DeActivateRepresentative(agentId).subscribe(
      d => {
        if (d.Success) {

          this.showRequest = true; 
          this.isErrorMessage = false;
        }
        else {
          this.showRequest = true;
          this.isErrorMessage = true;
         // this.alertService.error(this.translate.instant('FRONT_USER.ERRORS_MESSAGES.' + d.ErrorMessages[0]));

        }
      }
    )
  }
}
